import { PropsWithChildren } from "react";

type ContentProps = PropsWithChildren & {
  className?: string;
};
export const ContentBox: React.FC<ContentProps> = ({ children }) => {
  return <>{children}</>;
};

export const Content: React.FC<ContentProps> = ({ children, className = "" }) => <div className={`px-4 py-2 ${className}`}>{children}</div>;

export const Separator: React.FC = () => <div className="w-full border-t border-stroke-light h-[1px]" />;
